import { TFunction } from 'i18next';
import { ReactNode } from 'react';

import { SegmentedControlItem } from '@mantine/core';

import { Dictionary } from '#/shared/dictionaries';
import { NotificationSettingValue } from '#/entities/notification-setting';

export class NotificationSettingValueDictionary extends Dictionary<
  typeof NotificationSettingValue
> {
  constructor(t: TFunction) {
    super(NotificationSettingValue, t, 'notificationSetting');
  }

  // TODO type any
  toSegmentedControlItems(
    renderLabel: (item: any) => ReactNode = (item) => item.title
  ): SegmentedControlItem[] {
    return this.getAll().map((item) => ({
      value: String(item.id),
      label: renderLabel(item)
    }));
  }
}
